import styled from 'styled-components';

export const TooltipWrapper = styled.div`
  .react-tooltip {
    max-width: 360px;
    padding: 16px;
    background-color: ${(props) => props.theme.colors.bgBox};
    color: ${(props) => props.theme.colors.textPrimary};
    border: 1px solid #c4d4e4;
    z-index: 100;
  }

  .react-tooltip-arrow {
    border: inherit;
  }

  .react-tooltip__place-top .react-tooltip-arrow {
    border-style: none solid solid none;
  }

  .react-tooltip__place-right .react-tooltip-arrow {
    border-style: none solid solid none;
  }

  .react-tooltip__place-left .react-tooltip-arrow {
    border-style: none solid solid none;
  }

  .react-tooltip__place-bottom .react-tooltip-arrow {
    border-style: none solid solid none;
  }

  &.secondary {
    .react-tooltip {
      background-color: ${(props) => props.theme.colors.white};
    }
  }
`;
